export default __webpack_public_path__ + "static/media/Sample-Bequest-Wording-Maor.ca07fa27.pdf";